// import * as Klaro from 'klaro';

export default {
    init() {
        /*const cookieBannerFields = document.querySelector(
            '#cookie-banner-fields'
        ) as HTMLElement;

        if (!cookieBannerFields) return;

        const showModal = Boolean(cookieBannerFields.dataset.showModal);
        let cookieBannerText;

        if (cookieBannerFields.dataset.cookieText) {
            cookieBannerText = JSON.parse(
                cookieBannerFields.dataset.cookieText
            );
        }

        const config = {
            elementID: 'cookie-banner',
            storageMethod: 'cookie',
            storageName: 'klaro-cookie',
            mustConsent: showModal, // Cookie banner is a Modal
            acceptAll: true,
            hideDeclineAll: false,
            translations: {
                de: {
                    privacyPolicyUrl:
                        cookieBannerText['de']['privacyPolicyUrl'],
                    consentNotice: {
                        description:
                            cookieBannerText['de']['consentNoticeDescription'],
                        learnMore:
                            cookieBannerText['de']['consentNoticeLearnMore']
                    },
                    consentModal: {
                        title: cookieBannerText['de']['consentModalTitle'],
                        description:
                            cookieBannerText['de']['consentModalDescription'],
                        privacyPolicy: {
                            text: cookieBannerText['de'][
                                'consentModalPrivacyPolicyText'
                            ]
                        }
                    },
                    ok: cookieBannerText['de']['ok'],
                    decline: cookieBannerText['de']['decline'],
                    acceptSelected: cookieBannerText['de']['acceptSelected'],
                    save: cookieBannerText['de']['save'],
                    close: cookieBannerText['de']['close'],
                    acceptAll: cookieBannerText['de']['acceptAll'],
                    purposes: {
                        functional:
                            cookieBannerText['de']['purposes'][0]['functional'] ? cookieBannerText['de']['purposes'][0]['functional'] : null,
                        essential:
                            cookieBannerText['de']['purposes'][0]['essential'] ? cookieBannerText['de']['purposes'][0]['essential'] : null,
                        analytics:
                            cookieBannerText['de']['purposes'][0]['analytics'] ? cookieBannerText['de']['purposes'][0]['analytics'] : null,
                        marketing:
                            cookieBannerText['de']['purposes'][0]['marketing'] ? cookieBannerText['de']['purposes'][0]['marketing'] : null
                    },
                    service: {
                        disableAll: {
                            description: cookieBannerText.de
                                .serviceDisableAllDescription
                                ? cookieBannerText.de
                                    .serviceDisableAllDescription
                                : null,
                            title: cookieBannerText.de.serviceDisableAllTitle
                                ? cookieBannerText.de.serviceDisableAllTitle
                                : null
                        }
                    }
                },
                en: {
                    privacyPolicyUrl:
                        cookieBannerText['en']['privacyPolicyUrl'],
                    consentNotice: {
                        description:
                            cookieBannerText['en']['consentNoticeDescription'],
                        learnMore:
                            cookieBannerText['en']['consentNoticeLearnMore']
                    },
                    consentModal: {
                        title: cookieBannerText['en']['consentModalTitle'],
                        description:
                            cookieBannerText['en']['consentModalDescription'],
                        privacyPolicy: {
                            text: cookieBannerText['en'][
                                'consentModalPrivacyPolicyText'
                            ]
                        }
                    },
                    ok: cookieBannerText['en']['ok'],
                    decline: cookieBannerText['en']['decline'],
                    acceptSelected: cookieBannerText['en']['acceptSelected'],
                    save: cookieBannerText['en']['save'],
                    close: cookieBannerText['en']['close'],
                    acceptAll: cookieBannerText['en']['acceptAll'],
                    purposes: {
                        functional:
                            cookieBannerText['en']['purposes'][0]['functional'] ? cookieBannerText['en']['purposes'][0]['functional'] : null,
                        essential:
                            cookieBannerText['en']['purposes'][0]['essential'] ? cookieBannerText['en']['purposes'][0]['essential'] : null,
                        analytics:
                            cookieBannerText['en']['purposes'][0]['analytics'] ? cookieBannerText['en']['purposes'][0]['analytics'] : null,
                        marketing:
                            cookieBannerText['en']['purposes'][0]['marketing'] ? cookieBannerText['en']['purposes'][0]['marketing'] : null
                    }
                }
            },
            services: [
                // Essential cookies - technically necessary services for the basic functionality of the website
                {
                    name: 'craft-cms',
                    title: 'Craft CMS',
                    default: true,
                    purposes: ['essential'],
                    cookies: [
                        ['CraftSessionId'],
                        ['*_identity'],
                        ['*_username'],
                        ['CRAFT_CSRF_TOKEN'],
                        ['cw_conversation'],
                        ['auth-cookie'],
                        ['variant']
                    ],
                    required: true
                },
                {
                    name: 'klaro',
                    title: 'Klaro!',
                    purposes: ['essential'],
                    required: true
                },
                // Functional cookies - necessary to provide features, such as prettier fonts, video playback or interactive Web 2.0 features
                {
                    name: 'youtube',
                    title: 'Youtube',
                    purposes: ['functional'],
                    cookies: [['YSC'], ['VISITOR_INFO1_LIVE']],
                    required: false
                },
                {
                    name: 'calendly',
                    title: 'Calendly',
                    purposes: ['functional'],
                    cookies: [
                        [/^_ga.*$/i, '/', '.calendly.com'],
                        ['ajs_anonymous_id', '/', '.calendly.com'],
                        ['_ga', '/', '.calendly.com'],
                        ['_gid', '/', '.calendly.com'],
                        ['__cf_bm', '/', '.calendly.com'],
                        ['__stripe_mid', '/', '.calendly.com'],
                        ['_mkto_trk', '/', '.calendly.com'],
                        ['__cfruid', '/', '.calendly.com'],
                        ['fs_lua', '/', '.calendly.com'],
                        ['_hp2_id.3509290134', '/', '.calendly.com'],
                        ['_hp2_ses_props.3509290134', '/', '.calendly.com'],
                        ['fs_uid', '/', '.calendly.com']
                    ],
                    required: false
                },
                // Analytics - help to observe a user's behavior on the website
                {
                    name: 'gtm',
                    title: 'Google Tag Manager',
                    purposes: ['analytics'],
                    cookies: [
                        [/^_ga.*$/i, '/', '.froots.io'],
                        ['_gid', '/', '.froots.io'],
                        [/^_dc_gtm.*$/i, '/', '.froots.io'],
                        [/^_gtm.*$/i, '/', '.froots.io'],
                        [/^_ga.*$/i, '/', '.froots.test'], // for local page
                        ['_gid', '/', '.froots.test'], // for local page
                        [/^_dc_gtm.*$/i, '/', '.froots.test'], // for local page
                        [/^_gtm.*$/i, '/', '.froots.test'] // for local page
                    ],
                    required: false
                },
                // {
                //     name: 'google-analytics',
                //     title: 'Google Analytics',
                //     purposes: ['analytics'],
                //     cookies: [
                //         [/^_ga.*$/i, '/', '.froots.io'],
                //         ['_gid', '/', '.froots.io'],
                //         [/^_ga.*$/i, '/', '.froots.test'], // for local page
                //         ['_gid', '/', '.froots.test'] // for local page
                //     ],
                //     required: false
                // },
                // Marketing - are used to record the behavior of individual users, to analyze the data and, e.g to display personalized advertising
                 {
                     name: 'gtm_ad',
                     title: 'Google Tag Manager',
                     purposes: ['marketing'],
                     cookies: [],
                     required: false
                 }
            ]
        };

        // we assign the Klaro module to the window, so that we can access it in JS
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const w = window as any;
        w.klaro = {};
        w.klaro = Klaro;
        w.klaroConfig = config;
        // we set up Klaro with the config
        Klaro.setup(config);*/
    }
};
